<template>
  <v-date-picker
    v-model="selectedDate"
    mode="single"
    tint-color="#eb336a"
    v-bind="$attrs"
    popover-visibility="focus"
  >
    <slot />
  </v-date-picker>
</template>

<script>

export default {

  data() {
    return {
      selectedDate: new Date(),
    };
  },

  watch: {
    selectedDate(date) {
      this.$emit('pick', { date });
    },
  },
};

</script>
